import {
  // eslint-disable-next-line import/named
  PayloadAction,
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { AppDispatch, RootState } from '../../../stateStore'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import employeeAllocationReportApi from '../../../middleware/api/ProjectManagement/EmployeeAllocation/employeeAllocationApi'
import {
  AllocationStatusTypes,
  EmployeeAllocationReportProps,
  EmployeeAllocationReportState,
  EmployeeAllocationReportType,
  ProjectUnderEmployees,
  ProjectUnderEmployeesProps,
  UpdateEmployeeAllocationProject,
} from '../../../types/ProjectManagement/EmployeeAllocation/employeeAllocationTypes'
import {
  CheckEnum,
  filterOptionsStatus,
} from '../../../pages/ProjectManagement/EmployeeAllocation/AllocationFilterHelper'

const getEmployeeAllocationReport = createAsyncThunk(
  'employeeAllocation/getEmployeeAllocationReport',
  async (props: EmployeeAllocationReportProps, thunkApi) => {
    try {
      return await employeeAllocationReportApi.getEmployeeAllocationReport(
        props,
      )
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const projectUnderEmployeesReport = createAsyncThunk(
  'employeeAllocation/projectUnderEmployees',
  async (props: ProjectUnderEmployeesProps, thunkApi) => {
    try {
      return await employeeAllocationReportApi.projectUnderEmployeesReport(
        props,
      )
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const updateEmployeeAllocationProject = createAsyncThunk<
  number | undefined,
  UpdateEmployeeAllocationProject,
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: ValidationError
  }
>(
  'employeeAllocation/updateEmployeeAllocationProject',
  async (
    updateEmployeeAllocation: UpdateEmployeeAllocationProject,
    thunkApi,
  ) => {
    try {
      return await employeeAllocationReportApi.updateEmployeeAllocationProject(
        updateEmployeeAllocation,
      )
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialEmployeeAllocationReportState: EmployeeAllocationReportState = {
  Empsize: 0,
  emps: [],
  projectUnderEmployees: [],
  isLoading: ApiLoadingState.idle,
  employeeAllocationReportType: {} as EmployeeAllocationReportType,
  error: null,
  StatusValue: [],
  checkedItems: [],
}
const employeeAllocationSlice = createSlice({
  name: 'employeeAllocation',
  initialState: initialEmployeeAllocationReportState,
  reducers: {
    setStatusValue: (state, action) => {
      state.StatusValue = action.payload
    },
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload
    },
    setStatusEmployeeAllocationList: (
      state,
      action: PayloadAction<{
        type: CheckEnum
        value: string
        indexVal: number
      }>,
    ) => {
      const { type, value, indexVal } = action.payload
      if (type === CheckEnum.checkAll.toString()) {
        state.StatusValue = {
          ...state.StatusValue,
          ...Object.fromEntries(
            filterOptionsStatus.map((val: AllocationStatusTypes) => [
              val.label,
              val,
            ]),
          ),
        }
      } else if (type === CheckEnum.uncheckAll.toString()) {
        state.StatusValue = {
          ...state.StatusValue,
        }
      } else if (type === CheckEnum.checkNum.toString()) {
        state.StatusValue.push(value)
      } else {
        state.StatusValue.splice(indexVal, 1)
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getEmployeeAllocationReport.pending, (state) => {
      state.isLoading = ApiLoadingState.loading
    })
    builder.addCase(projectUnderEmployeesReport.pending, (state) => {
      state.isLoading = ApiLoadingState.loading
    })
    builder.addCase(getEmployeeAllocationReport.fulfilled, (state, action) => {
      state.isLoading = ApiLoadingState.succeeded
      state.employeeAllocationReportType = action.payload
    })
    builder.addCase(projectUnderEmployeesReport.fulfilled, (state, action) => {
      state.isLoading = ApiLoadingState.succeeded
      state.projectUnderEmployees = action.payload
    })
  },
})

const employeeAllocationReport = (
  state: RootState,
): EmployeeAllocationReportType =>
  state.employeeAllocationReport.employeeAllocationReportType

const employeeUnderProject = (state: RootState): ProjectUnderEmployees[] =>
  state.employeeAllocationReport.projectUnderEmployees

const isLoading = (state: RootState): LoadingState =>
  state.employeeAllocationReport.isLoading

const getStatusValue = (state: RootState): string[] =>
  state.employeeAllocationReport.StatusValue

const getCheckedItems = (state: RootState): AllocationStatusTypes[] =>
  state.employeeAllocationReport.checkedItems

const employeeMailConfigurationThunk = {
  getEmployeeAllocationReport,
  projectUnderEmployeesReport,
  updateEmployeeAllocationProject,
}

const employeeAllocationSelectors = {
  employeeAllocationReport,
  employeeUnderProject,
  isLoading,
  getStatusValue,
  getCheckedItems,
}

export const employeeAllocationSliceService = {
  ...employeeMailConfigurationThunk,
  actions: employeeAllocationSlice.actions,
  selectors: employeeAllocationSelectors,
}

export default employeeAllocationSlice.reducer
